<google-map 
    width="100%"
    [center]="center"
    [zoom]="zoom"
    (mapMousemove)="move($event)"
    (mapClick)="closeInfoWindow()">
    <map-marker *ngFor="let marker of points; let ix = index"
        [position]="marker.position" [title]="marker.title" 
        [options]="marker.options"
        (mapClick)="openInfoWindow(ix, marker.label)">
    </map-marker>
    <map-info-window [title]="" [innerHTML]="infoContent"></map-info-window>        
</google-map>